module.exports = __webpack_public_path__ + "img/poster-wakethetown.ab76293b.png";